import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5512ae1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work" }
const _hoisted_2 = { class: "tab_left" }
const _hoisted_3 = { class: "tab_left_header" }
const _hoisted_4 = { class: "tab_left_list" }
const _hoisted_5 = { class: "operation_box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "mod_pagin"
}
const _hoisted_10 = { class: "create_modal" }
const _hoisted_11 = { class: "create_modal_line align_center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 导播名称：")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "create_modal_title" }, "类型："),
  /*#__PURE__*/_createElementVNode("div", null, "通用型")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "create_modal_title" }, "计费方式："),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("div", null, "按时长"),
    /*#__PURE__*/_createElementVNode("div", { class: "create_modal_text" }, "根据导播台类型和输入分辨率规格不同，按分钟计费，每小时出账，实时扣费。")
  ])
], -1))
const _hoisted_15 = { class: "config_modal" }
const _hoisted_16 = { class: "config_modal_line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "导播台ID", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "域名"),
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_txt" }, "默认从直播域名列表中获取；若需使用新的播放域名，请到域名管理页添加域名")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "录制设置"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" 未配置 "),
    /*#__PURE__*/_createElementVNode("p", { class: "config_modal_line_txt" }, "开启录制后，自动录制直播内容并生成视频至指定存储位置（查看OSS计费说明）")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "备播视频"),
  /*#__PURE__*/_createElementVNode("div", null, "未配置")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "延时播放"),
  /*#__PURE__*/_createElementVNode("div", null, "未配置")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "备播视频"),
  /*#__PURE__*/_createElementVNode("div", null, "未配置")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "config_modal_line_title" }, "播放信息"),
  /*#__PURE__*/_createElementVNode("div", null, "没有播放地址")
], -1))
const _hoisted_24 = { class: "copy_modal" }
const _hoisted_25 = { class: "create_modal_line align_center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create_modal_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode(" 导播名称：")
], -1))

import { reactive, ref } from 'vue';
import { Tabs, Table, Pagination, Modal, message, Tooltip, Drawer, Input, Alert } from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import { DataClass, columns, IData, pageConfig } from './type';
import http from '@/api';
import { RangePickerIcon } from '@/assets';
import { SearchOutlined } from '@ant-design/icons-vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'CloudGuide',
  setup(__props) {

const aTabs = Tabs;
const aTabPane = Tabs.TabPane;
const aTable = Table;
const aPagination = Pagination;
const aModal = Modal;
const aTooltip = Tooltip;
const aDrawer = Drawer;
const aInputSearch = Input.Search;
const aAlert = Alert;
const dataSource = ref<DataClass[]>([]);
const selectedRowKeys = ref();
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const keyword = ref('');
const searchChange = useDebounce(() => {
  getDataList();
});

// 获取列表
const getDataList = () => {
  pageConfig.loading = true;
  http.application
    .get_describe_caster_channels({ page: pageConfig.current, page_num: pageConfig.pageSize, keyword: keyword.value })
    .then((res) => {
      dataSource.value = res.data.data.data.map((e: IData) => new DataClass(e));
      pageConfig.totalSize = res.data.data.total;
      pageConfig.current = res.data.data.current_page;
    })
    .finally(() => (pageConfig.loading = false));
};
getDataList();

// 创建
const createGuideModal = reactive<RootModal>({
  title: '欢迎使用云导播台',
  visible: false,
  loading: false,
});
const openCreateGuide = () => {
  createGuideModal.visible = !createGuideModal.visible;
};
const cloudGuideName = ref(''); //创建导播台名称
const createCaster = useDebounce(() => {
  if (cloudGuideName.value === '') {
    message.info('导播名称不能为空！');
    return;
  }
  http.application
    .create_caster({ CasterName: cloudGuideName.value, NormType: 1, ChargeType: 'PostPaid' })
    .then(() => {
      message.success('创建成功！');
      openCreateGuide();
      getDataList();
    })
    .catch(() => message.error('创建失败！'));
});
// 进入
const toCloudGuide = (clientToken: string) => {
  const url = process.env.VUE_APP_Guide_LINK + '?CasterId=' + clientToken;
  window.open(url);
};

// 查看配置
const configGuideModal = reactive<RootModal>({
  title: '导播台配置',
  visible: false,
  loading: false,
});
const openConfigGuideModal = (casterId: string) => {
  configGuideModal.visible = true;
  CasterId.value = casterId;
  getConfigInfo();
};
const getConfigInfo = () => {
  Promise.all([
    http.application.describe_caster_config({ CasterId: CasterId.value }),
    http.application.describe_caster_stream_url({ CasterId: CasterId.value }),
    // http.application.get_play_info({})
  ]).then(([res1, res2]) => {
    res1;
    res2;
  });
};
// 复制
const copyGuideModal = reactive<RootModal>({
  title: '复制导播台',
  visible: false,
  loading: false,
});
const copyCasterName = ref('');
const openCopyGuideModal = (record: DataClass) => {
  copyGuideModal.visible = true;
  CasterId.value = record.casterId;
  copyCasterName.value = record.name + '副本';
};
const copyCaster = useDebounce(() => {
  http.application
    .copy_caster({ CasterName: copyCasterName.value, SrcCasterId: CasterId.value })
    .then(() => {
      message.success('复制成功！');
      copyGuideModal.visible = false;
      getDataList();
    })
    .catch(() => message.error('复制失败！'));
});
// 删除
const delModal = reactive<RootModal>({
  title: '删除',
  visible: false,
  loading: false,
});

const CasterId = ref();
const openDelModal = (casterId: string) => {
  delModal.visible = true;
  CasterId.value = casterId;
};
const closeDelModal = () => {
  delModal.visible = false;
};
const clickDelCaster = useDebounce(() => {
  delModal.loading = true;
  http.application
    .delete_caster({ CasterId: CasterId.value })
    .then(() => {
      message.success('删除成功！');
      delModal.loading = false;
      closeDelModal();
      getDataList();
    })
    .catch((err) => {
      message.error(err.data.error);
      delModal.loading = false;
    });
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(aAlert), {
      message: "直接关闭页面不会停止直播和PGM输出，导播台会持续运行并计费，若要停止使用请务必点击【停止直播】",
      type: "warning",
      closable: ""
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search",
          value: keyword.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          placeholder: "请输入导播台名称",
          onSearch: _unref(searchChange)
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined), { color: "#fff" })
          ]),
          _: 1
        }, 8, ["value", "onSearch"]),
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: openCreateGuide
          }, {
            default: _withCtx(() => [
              _createTextVNode("新建云导播台")
            ]),
            _: 1
          }),
          _createTextVNode("   "),
          _createVNode(_component_a_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openDelModal(selectedRowKeys.value.join())))
          }, {
            default: _withCtx(() => [
              _createTextVNode("删除")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(aTable), {
          "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
          columns: _unref(columns),
          "data-source": dataSource.value,
          scroll: { x: 1500, y: false },
          pagination: false,
          loading: _unref(pageConfig).loading,
          rowKey: "casterId"
        }, {
          operation: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(aTooltip), null, {
                title: _withCtx(() => []),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "operation_box_btn",
                    onClick: ($event: any) => (toCloudGuide(record.clientToken))
                  }, " 进入 ", 8, _hoisted_6)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(aTooltip), null, {
                title: _withCtx(() => []),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "operation_box_btn",
                    onClick: ($event: any) => (openCopyGuideModal(record))
                  }, " 复制 ", 8, _hoisted_7)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(aTooltip), null, {
                title: _withCtx(() => []),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "operation_box_btn",
                    onClick: ($event: any) => (openDelModal(record.casterId))
                  }, " 删除 ", 8, _hoisted_8)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["row-selection", "columns", "data-source", "loading"]),
        (dataSource.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(aPagination), {
                "show-quick-jumper": "",
                total: _unref(pageConfig).totalSize,
                current: _unref(pageConfig).current,
                "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pageConfig).current) = $event)),
                "page-size": _unref(pageConfig).pageSize,
                "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pageConfig).pageSize) = $event)),
                pageSizeOptions: _unref(pageConfig).options,
                "show-less-items": "",
                "show-size-changer": "",
                onChange: getDataList,
                onShowSizeChange: getDataList
              }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(aModal), {
        visible: createGuideModal.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((createGuideModal.visible) = $event)),
        title: createGuideModal.title,
        width: "620px",
        centered: "",
        onOk: _unref(createCaster)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_a_input, {
                value: cloudGuideName.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((cloudGuideName).value = $event)),
                placeholder: "请输入导播名称",
                maxLength: "10",
                suffix: `${cloudGuideName.value.length} / 10`,
                class: "line_in"
              }, null, 8, ["value", "suffix"])
            ]),
            _hoisted_13,
            _hoisted_14
          ])
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk"]),
      _createVNode(_unref(aDrawer), {
        title: configGuideModal.title,
        placement: "right",
        closable: true,
        visible: configGuideModal.visible,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((configGuideModal.visible) = $event)),
        width: 700
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", null, _toDisplayString(CasterId.value), 1)
            ]),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23
          ])
        ]),
        _: 1
      }, 8, ["title", "visible"]),
      _createVNode(_unref(aModal), {
        visible: copyGuideModal.visible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((copyGuideModal.visible) = $event)),
        title: copyGuideModal.title,
        centered: "",
        onOk: _unref(copyCaster)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_a_input, {
                value: copyCasterName.value,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((copyCasterName).value = $event)),
                placeholder: "请输入导播名称",
                class: "line_in"
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title", "onOk"]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: closeDelModal,
        ok: _unref(clickDelCaster),
        loading: delModal.loading
      }, null, 8, ["visible", "ok", "loading"])
    ])
  ]))
}
}

})